let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hnYTT"), load("kD057")]).then(() => parcelRequire('KcDfp'));